/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import followerGetters from "./followers/getters";

export default {
	getEvent: (state) => (eventId) => state.events.find((event) => event.id === eventId),
	getEventByCalendarId: (state) => (eventId) => state.events.find((event) => event.calendarId === eventId),
	getCurrentResource: (state) => state.currentResource,
	getEventStaticMapsImageRequest: (state) => (vpId) => state.scheduleMapStaticImageRequests.get(vpId) || null,
	getSelectedEvents: (state) => state.selectedEvents,
	getSelectedEventById: (state) => (eventId) => state.selectedEvents.find((event) => event.id === eventId),
	getCachedEvents: (state) => state.cachedEvents,
	getCachedEventById: (state) => (eventId) => state.cachedEvents.find((event) => event.id === eventId),
	...followerGetters,
};
